
$(document).ready(function(){

  $('#owl-collection').owlCarousel({
    loop: true,
    dots: false,
    nav: false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  });
});

$(document).ready(function(){
  $('#owl-test').owlCarousel({
    loop: true,
    autoplay: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        dots: true,
        nav: false,
      },
      600: {
        items: 1,
        dots: true,
        nav: false,
      },
      800: {
        dots: false,
        items: 1,
        nav: true,
      },
      1000: {
        dots: false,
        items: 1,
        nav: true,
      },
      1200: {
        dots: false,
        items: 1,
        nav: true,
      }
    }
  });
});
